import { Button, Col, Row } from "antd";
import { Fade } from "react-reveal";
import BotonCard from "../components/Boton/BotonCard";
import BotonDiv from "../components/Boton/BotonDiv";

export default function CardPage({
  children,
  titulo,
  tituloBoton,
  accionBoton,
  tituloBoton2,
  accionBoton2,
}) {
  return (
    <Fade>
      <div style={{ marginBottom: 15 }}>
        <Row>
          <Col span={12} className="card__titulo_container">
            <div className="card__titulo">{titulo}</div>
          </Col>
          <Col span={12} className="card__accion">
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              {tituloBoton2 && (
                <BotonDiv onClick={accionBoton2} tituloBoton={tituloBoton2} />
              )}
              {tituloBoton && (
                <BotonDiv onClick={accionBoton} tituloBoton={tituloBoton} />
              )}
            </div>
          </Col>
        </Row>

        <div className="card__contenido">{children}</div>
      </div>
    </Fade>
  );
}
